<template>
  <section
    v-if="underwriting.length>0"
    class="excess-form">
    <div class="box">
      <h3>Underwriting Question</h3>
      <div class="flex-sb-wrap">
        <div
          v-for="(inItem, inIndex) in underwriting"
          :key="inIndex"
          class="form-item form-half">
          <span>{{ inItem.name }}</span>
          <v-radio-group
            v-model="inItem.answer"
            :border="true"
            :disabled="disabled"
            :list="yesNoOptions"
            @change="handlerBenefits"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getReferralUnderwriting} from '@/api/refer'
import {getRenewReferUnderwriting} from '@/api/renewal'

export default {
  name: 'referUnderwirting',
  mixins: [MixinOptions],
  props: {
    classId: {
      type: [Number, String],//14 motor 21 domestic 24 decoration 26 home &fire
      default: ''
    },
    form: {
      type: Object,
      default: () => ({})
    },
    referId: {
      type: [String, Number],
      default: ''
    },
    formDataLock: {
      type: Number,
      default: 0,
    },
    disabled:{
      type:Boolean,
      default:false
    },
    index: {
      type: Number,
      default: 0
    },
    editType: {
      type: Number,
      default: 0
    },
    renewOrderId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      oldFormDataLock: -1,
      underwriting: [],
      benefits:[]
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      immediate: true,
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
          if([11,12,14].includes(this.classId))
          {
            let {company_id,trm_of_cvr,refer_id} = this.form||{}
            if(company_id&&trm_of_cvr)
            {
              let params = {
                company_id,
                plan_id:trm_of_cvr,
                refer_id,
                order_id: this.renewOrderId
              }
              this.$nextTick(() => {
                this.network().getReferralUnderwriting(params)
              })
            }
          }
        }
      }
    },
    classId: {
      immediate: true,
      handler(val) {
        if (val) {
          if([11,12,14].includes(val))
          {
            let {company_id,trm_of_cvr,refer_id} = this.form||{}
            if(company_id&&trm_of_cvr)
            {
              let params = {
                company_id,
                plan_id:trm_of_cvr,
                refer_id,
                order_id: this.renewOrderId
              }
              this.$nextTick(() => {
                this.network().getReferralUnderwriting(params)
              })
            }
          }
        }
      }
    },
    'form.plan_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val && this.formDataLock !== this.oldFormDataLock) {
          this.oldFormDataLock = this.formDataLock
          const { company_id, plan_id, refer_id } = this.form
          let params = {
            company_id,
            plan_id,
            refer_id,
            order_id: this.renewOrderId
          }
          if(![11,12,14].includes(this.classId))
            this.$nextTick(() => {
              this.network().getReferralUnderwriting(params)
            })
        }
      }
      // }
    },
    benefits:{
      immediate:true,
      handler(val = [], old=[]) {
        if([11, 12].includes(Number(this.classId))) {
          const arr = this.classId == 11?
            [256, 512]:
            [4, 8, 16]
          // 新增才需要考慮
          if(val.length > old.length) {
            // 判斷有多少個是衝突的
            const filterList = val.filter(item => arr.includes(item))
            if(filterList.length > 1) {
              let flag = false
              const result = val.reduce((result, item) => {
                if(arr.includes(item) && !flag) {
                  flag = true
                  return result
                }
                result.push(item)
                return result
              }, [])
              this.benefits = JSON.parse(JSON.stringify(result))
            }
          }
        }
      }
    },
  },
  methods: {
    handlerBenefits(){
      const params ={
        underwriting:this.underwriting
      }
      this.$emit('getSubmitPremium', params, this.index)
    },
    submitForm(formName) {
      // const params = JSON.parse(JSON.stringify(this.excessForm))
      const params ={
        underwriting:this.underwriting
      }
      this.$emit('getFormData', formName,params,this.index)
    },
    network() {
      return {
        getReferralUnderwriting: async (params) => {
          if(this.editType == 3){
            if(params.order_id > 0){
              var {data} = await getRenewReferUnderwriting({
                ...params,
                hideLoading: true
              })
            }
          }else{
            var { data } = await getReferralUnderwriting({
              ...params,
              hideLoading: true
            })
          }
          if(data){
            this.$emit('sendPlanCvrRemark',data.plan_cvr_remark)
            this.underwriting = data.underwriting
            let { underwriting=[]} = this.form||{}
            // if(underwriting)
            // {
            let  underwritings = JSON.parse(JSON.stringify(underwriting))||[]
            this.underwriting.map(item=>{
              let same = underwritings.filter(under=>under.id==item.id)||[]
              if (same.length>0)
              {
                let {answer=1} =  same[0]||{}
                item.answer = answer
              }else {
                item.answer = 1
              }
            })
            // }
            this.handlerBenefits()
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box{
  width: 100%;
}
.excess-form {
  .flex-excess {
    display: flex;
    align-items: center;
    & > .el-checkbox {
      margin: 0 15px;
    }
    & > span {
      display: inline-block;
      padding: 0 15px;
    }
  }
  .form-excess-half {
    width: 500px;
  }
}
</style>
